import OmniauthLinksController from './controllers/omniauth_links_controller'

window.stimulusApp.register('omniauth-links', OmniauthLinksController)
